// components
import { Footer } from "components/Footer";
import { Header } from "components/Header";

// assets
import BGImage from "assets/bg.png";

export const Layout = ({ children }) => {
  return (
    <>
      <div
        class="h-full pb-14 bg-right bg-contain bg-no-repeat md:bg-top"
        style={{ backgroundImage: `url(${BGImage})` }}
      >
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  );
};
